var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import colors from "../../designSystem/colors";
var Link = styled.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  text-decoration: underline;\n\n  &:hover {\n    color: ", "CC;\n  }\n"], ["\n  color: ", ";\n  text-decoration: underline;\n\n  &:hover {\n    color: ", "CC;\n  }\n"])), colors.primaryText, colors.primaryText);
export var vaultAudit = function (vaultOption) {
    if (vaultOption === "rSOL-THETA") {
        return (_jsxs(_Fragment, { children: ["The Flex Vault smart contracts are pending audit and so should be considered as beta software. Users are advised to exercise caution and only risk funds they can afford to lose.", " "] }, void 0));
    }
    else {
        return (_jsxs(_Fragment, { children: ["The Theta Vault smart contracts have been", " ", _jsx(Link, __assign({ href: "https://blog.openzeppelin.com/ribbon-finance-audit/", target: "_blank", rel: "noreferrer noopener" }, { children: "audited by OpenZeppelin" }), void 0), " ", "and", " ", _jsx(Link, __assign({ href: "https://github.com/ribbon-finance/audit/blob/master/reports/RibbonThetaVault%20V2%20Smart%20Contract%20Review%20And%20Verification.pdf", target: "_blank", rel: "noreferrer noopener" }, { children: "ChainSafe" }), void 0), ". Despite that, users are advised to exercise caution and only risk funds they can afford to lose."] }, void 0));
    }
};
var templateObject_1;
//# sourceMappingURL=productCopies.js.map